class WindowScrollObserver {
	fastSpeedLimit = 500;
	previousScrollY = 0;
	delay = 250;
	interval = 0;

	constructor() {
		window.setInterval(this.run.bind(this), this.delay);
	}

	get isFastScroll() {
		return Math.abs(window.scrollY - this.previousScrollY) > this.fastSpeedLimit;
	}

	run() {
		this.previousScrollY = window.scrollY;
	}
}

export default WindowScrollObserver;
